<template>
  <v-card flat tile>
    <v-flex class="pl-2 mt-4">
      <span class="title">【温馨提示】</span>
    </v-flex>
    <v-flex class="pl-2 pr-2">
      <v-textarea v-model="msg" auto-grow readonly></v-textarea>
    </v-flex>
    <v-card-title style="height: 20px;" class="title mb-4">
      <div>
        <p>进校登记日志</p>
      </div>
      <!-- <div>
         <span class="error&#45;&#45;text" style="font-size: 14px">*如需修改个人资料，请前往人力资源部</span>
       </div>-->
    </v-card-title>
    <v-layout>
      <l-data-table
      :get-data-func="getRecord"
      hide-title
      hide-refresh
      hide-title-search
      clickable
      @click:row="getDetails($event.item)"
      :headers="header"></l-data-table>
    </v-layout>
  </v-card>
</template>

<script>
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
    import {time} from '../../../ladmin/utils/time'
    export default {
        name: "tempSelfSignRecord",
      components: {LDataTable},
      data(){
          return {
            // msg: "\t根据学校应对新型冠状病毒感染肺炎疫情防控工作领导小组工作部署，为了广大师生健康安全，自2020年1月28日下午6时起，实施校门临时管控措施。\n" +
            //   "\t进校时，请您用微信扫码登记，理解并配合校门岗位人员做好体温检测与盘问核查等工作。特殊时期，特殊管理，由此带来的不便，敬请理解、支持和配合。",
            msg: "",
            header:[
              {text:'通行校区',value:'park',align:'center',sortable:false},
              {text:'通行卡口',value:'controller',align:'center',sortable:false},
              {text:"通行时间",value:'passTimeServer',align:'center',sortable:false,}
            ]
          }
        },
      async created(){
        await this.$store.dispatch('login/initSystemInfo')
      },
      methods:{
          async getRecord({pagination, sortStack, filterItems, search}){
            let res = await this.$store.dispatch('wx/getTempSelfSignRecord',{pagination})
            if(res.data.status===1){
              let items = res.data.data.content
              for(let i=0;i<items.length;i++){
                if(items[i].controllerId===""||items[i].controllerId==="undefined"){
                  items[i].park = "N/A"
                  items[i].controller = "N/A"
                }
                else{
                  let c = await this.getController(items[i].controllerId)
                  if(c!==null){
                    items[i].park = c.parkingLot.name
                    items[i].controller = c.name
                  }else{
                    items[i].park = 'N/A'
                    items[i].controller = 'N/A'
                  }
                }
              }
              return {items:items,amount:res.data.data.totalElements}
            }else{
              return {items:[],amount:0}
            }
          },
        isVisitor(data){
          let groups = data.userInfo.userGroups
          for(let i=0;i<groups.length;i++){
            if(groups[i].groupTypes[0].name==='reg'){
              let name =groups[i].name
              if(name.indexOf('【登记】注册访客')!==-1){
                return true
              }else{
                return false
              }
            }
          }
          return false
        },
        async getController(id){
          let controllerList = this.$store.state.parkingLot.unDirControllerList
          let dirControllerList = this.$store.state.parkingLot.personControllerList
          let vehicleControllerList = this.$store.state.parkingLot.controllerList
          for(let i=0;i<controllerList.length;i++){
            if(controllerList[i].id === id){
              let dir = controllerList[i].dirgateList
              if(dir == null||dir.length == 0){
                let res = controllerList[i]
                res.inOrOut = ''
                res.parkingLot = {
                  name: controllerList[i].park && controllerList[i].park[0] && controllerList[i].park[0].name
                }
                return res
              }
              for(let j=0;j<dir.length;j++) {
                if (dir[j].passType == "0") {
                  dir[j].parkingLot = {
                    name: controllerList[i].park && controllerList[i].park[0] && controllerList[i].park[0].name
                  }
                  dir[j].name = controllerList[i].name||'N/A'
                  return dir[j]
                }
              }
            }
          }
          for(let i=0;i<dirControllerList.length;i++){
            if(dirControllerList[i].id === id){
              dirControllerList[i].name = dirControllerList[i].gateInfo.name||'N/A'
              return dirControllerList[i]
            }
          }
          console.log(44,id,vehicleControllerList)
           for(let i=0;i<vehicleControllerList.length;i++){
            if(vehicleControllerList[i].id === id){
              vehicleControllerList[i].name = vehicleControllerList[i].gateInfo.name||'N/A'
              return vehicleControllerList[i]
            }
          }
          return null
        },
        getDetails (item) {
          let selectionString = document.getSelection().toString()
          if (!selectionString) {
            this.$router.push({name: 'tempSelfSign', query: {passStatus:item.passStatus,controllerId: item.controllerId,status:'readonly',passTime:time.toTimeStamp(item.passTimeServer)}})
          }
        },
      }
    }
</script>

<style scoped>

</style>
